import { Store } from '@ngrx/store';
import { Injectable, OnChanges } from '@angular/core';
import { CookieStorage } from './classes/cookie-storage.class';

export type StorageType = 'cookie' | 'local' | 'session';

@Injectable()
export class StorageService {

    public local: Storage = localStorage;
    public cookie: CookieStorage = new CookieStorage();
    public session: Storage = sessionStorage;

}
